<qbit-dialog-header title="TABLE_SETTINGS" (close)="close()"></qbit-dialog-header>

<div class="bootstrap-wrapper">
    <div class="padd-20">
        <mat-checkbox [(ngModel)]="isRefreshEnabled" (ngModelChange)="refreshEnabledChanged($event)"
            [ngModelOptions]="{standalone: true}">
            {{'ENABLE_REFRESH' | translate}}
        </mat-checkbox>
    </div>
</div>